import * as React from 'react';
import { Tabs } from 'antd';

const { TabPane } = Tabs;

interface AppointmentConfigSwitcherProps {
  toggle: (key: string) => void;
  answeringSubscriptionExists: boolean;
  $rootScope: any;
}

const AppointmentConfigSwitcher: React.FC<AppointmentConfigSwitcherProps> = ({
  toggle,
  answeringSubscriptionExists,
  $rootScope,
}) => (
    <Tabs
      id="showingConfiguration"
      style={{ padding: '0px 18px' }}
      defaultActiveKey="appointment"
      onChange={toggle}
    >
      <TabPane tab="Showing Configuration" key="appointment" />
      {answeringSubscriptionExists && (
        <TabPane
          tab="Live Concierge Service"
          key="appointmentAnsweringService"
        />
      )}

      {$rootScope.hasFeature('COVID_19') && (
        <TabPane tab="Covid-19" key="covid19" />
      )}
    </Tabs>
  );

export default AppointmentConfigSwitcher;
